import React from 'react';
import Footer from './Footer';

function AboutUs() {
    return (
        <>
            <div className="wrapper pt-100px" style={{ marginBottom: '0px' }}>
                <div className="container-fluid">
                    <div className="row pt-2">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="aboutUsBox">
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 col-lg-7">
                                        <h3 className="pt-3">About Us</h3>
                                        <h1>Blue Resilience / Ulimi Wansomba</h1>
                                        <h2>Climate advisory tool for aquaculture/Climate  advisories for Fish</h2>
                                        <p className="pt-2">Climate variabilities and extremes have a profound influence on fisheries and aquaculture in SADC region.
                                            For instance, rising temperatures, unpredictable rainfall patterns, and extreme weather events like floods
                                            and strong winds, has had a major impact on Zambia's fisheries and aquaculture while Malawi is getting
                                            affected by higher temperatures, flooding, cyclones and windy storms. </p>
                                        <p>To address these climate variabilities induced risks, building climate resilience and institutional adaptability to
                                            shocks are critical to strengthen capacity and knowledge towards climate informed decision making. </p>
                                        <p>WorldFish with support from SADC secretariat and in close consultation with Department of Fisheries
                                            and Meteorological Departments in Zambia and Malawi, has developed this digital climate risk
                                            management tool for aquaculture to enhance climate-informed decision making under
                                            the PROFSIHBLUE project funded by African Development Bank and implemented by SADC secretariat. </p>
                                        <p>The main aim of developing this digital decision support system is to provide climate
                                            information services to fish-farmers and extension officers for a better
                                            decision-making approach and thus de-risking aquaculture value chains.
                                        </p>
                                    </div>
                                    <div className="col-sm-12 col-md-5 col-lg-5 pe-0">
                                        <div className="imgAbout">
                                            <img src="./assets/images/about-image.svg" className="w-100" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

            </div>

        </>
    )
}

export default AboutUs